import { useStrings } from "@1js/localization-components";
import { Tab, Text } from "@fluentui/react-components";
import React from "react";
import type { Appearance } from "../data";
import {
  MicrosoftPromptsLabel,
  SuggestedPromptsLabel,
} from "./PromptTab.strings";
import { PromptTabs } from "./PromptTabs";
import { useRocksteadyStyles, useStyles } from "./Tab.styles";

export const SuggestedTabTestId = "suggested-prompts-tab";

type SuggestedTabProps = {
  isSelected: boolean;
  appearance: Appearance;
  isRocksteadyUxEnabled?: boolean;
};

export const SuggestedTab: React.FC<SuggestedTabProps> = ({
  isSelected,
  appearance,
  isRocksteadyUxEnabled = false,
}) => {
  const localizations = useStrings({
    MicrosoftPromptsLabel,
    SuggestedPromptsLabel,
  });

  const tabLabel = React.useMemo(
    () =>
      isRocksteadyUxEnabled
        ? localizations.SuggestedPromptsLabel()
        : localizations.MicrosoftPromptsLabel(),
    [isRocksteadyUxEnabled, localizations]
  );

  const rocksteadyClasses = useRocksteadyStyles();
  const defaultClasses = useStyles(appearance)();
  const classes = isRocksteadyUxEnabled ? rocksteadyClasses : defaultClasses;

  return (
    <Tab
      aria-label={tabLabel}
      value={PromptTabs.AllPrompts}
      data-testid={SuggestedTabTestId}
      className={isSelected ? classes.selected : classes.tab}
    >
      <Text className={isSelected ? classes.selectedText : classes.text}>
        {tabLabel}
      </Text>
    </Tab>
  );
};
